{
  "metadata": {
    "id": "amoled-light",
    "name": "Amoled",
    "description": "Портировано из темы «AMOLED» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "amoled.json",
      "project": "opencode",
      "url": "https://github.com/anomalyco/opencode",
      "upstreamFile": "packages/ui/src/theme/themes/amoled.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 28.7,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.461,
      "paletteMaxS": 0.529,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.1,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 18.4,
      "syntaxVsTextMinDeltaE": 12.4,
      "chartsMinDeltaE": 59.7,
      "textSeparationDeltaE": 24.4,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#6200ff",
      "hover": "#5800e6",
      "active": "#5000d1",
      "foreground": "#ffffff",
      "muted": "#6200ff80",
      "emphasis": "#6200ff"
    },
    "surface": {
      "background": "#f0f0f0",
      "foreground": "#0a0a0a",
      "muted": "#c2c2c2",
      "mutedForeground": "#404040",
      "elevated": "#acacac",
      "elevatedForeground": "#0a0a0a",
      "raised": "#919191",
      "raisedForeground": "#0a0a0a",
      "overlay": "#f0f0f033",
      "subtle": "#d9d9d9"
    },
    "interactive": {
      "border": "#8b8b8b",
      "borderHover": "#b0b0b0",
      "borderFocus": "#6200ff",
      "selection": "#0a0a0a24",
      "selectionForeground": "#0a0a0a",
      "focus": "#6200ff59",
      "focusRing": "#6200ff47",
      "cursor": "#0a0a0a",
      "hover": "#0a0a0a17",
      "active": "#0a0a0a24"
    },
    "status": {
      "error": "#d9002a",
      "errorForeground": "#ffffff",
      "errorBackground": "#d9002a1a",
      "errorBorder": "#d9002a59",
      "warning": "#946300",
      "warningForeground": "#ffffff",
      "warningBackground": "#9463001a",
      "warningBorder": "#94630059",
      "success": "#007b3f",
      "successForeground": "#ffffff",
      "successBackground": "#007b3f1a",
      "successBorder": "#007b3f59",
      "info": "#0074a8",
      "infoForeground": "#ffffff",
      "infoBackground": "#0074a81a",
      "infoBorder": "#0074a859"
    },
    "pr": {
      "open": "#007b3f",
      "draft": "#505050",
      "blocked": "#946300",
      "merged": "#ff0080",
      "closed": "#d9002a"
    },
    "syntax": {
      "base": {
        "background": "#c2c2c2",
        "foreground": "#0a0a0a",
        "comment": "#4f4f4f",
        "keyword": "#8b00a2",
        "string": "#005c2f",
        "number": "#5800e6",
        "function": "#754300",
        "variable": "#0a0a0a",
        "type": "#940031",
        "operator": "#262626"
      },
      "tokens": {
        "commentDoc": "#4f4f4f",
        "stringEscape": "#262626",
        "keywordImport": "#8b00a2",
        "storageModifier": "#8b00a2",
        "functionCall": "#754300",
        "method": "#754300",
        "variableProperty": "#754300",
        "variableOther": "#0a0a0a",
        "variableGlobal": "#5800e6",
        "variableLocal": "#262626",
        "parameter": "#0a0a0a",
        "constant": "#5800e6",
        "class": "#940031",
        "className": "#940031",
        "interface": "#940031",
        "struct": "#940031",
        "enum": "#940031",
        "typeParameter": "#940031",
        "namespace": "#940031",
        "module": "#8b00a2",
        "tag": "#8b00a2",
        "jsxTag": "#8b00a2",
        "tagAttribute": "#754300",
        "tagAttributeValue": "#005c2f",
        "boolean": "#5800e6",
        "decorator": "#8b00a2",
        "label": "#754300",
        "regexp": "#005c2f"
      }
    },
    "charts": {
      "series": [
        "#6200ff",
        "#0074a8",
        "#007b3f",
        "#946300",
        "#d9002a"
      ]
    },
    "chat": {
      "background": "#f0f0f0",
      "userMessage": "#0a0a0a",
      "userMessageBackground": "#acacac",
      "assistantMessage": "#0a0a0a",
      "assistantMessageBackground": "#c2c2c2",
      "timestamp": "#505050",
      "divider": "#8b8b8b",
      "typing": "#505050"
    },
    "loading": {
      "spinner": "#6200ff",
      "spinnerTrack": "#c2c2c2",
      "skeleton": "#c2c2c2",
      "shimmer": "#b7b7b7"
    },
    "tools": {
      "background": "#c2c2c2",
      "border": "#8b8b8b",
      "headerHover": "#b9b9b9",
      "icon": "#6200ff",
      "title": "#0a0a0a",
      "description": "#505050",
      "edit": {
        "added": "#007b3f",
        "addedBackground": "#007b3f1a",
        "removed": "#d9002a",
        "removedBackground": "#d9002a1a",
        "modified": "#0074a8",
        "modifiedBackground": "#0074a81a",
        "lineNumber": "#505050"
      }
    },
    "markdown": {
      "heading1": "#0a0a0a",
      "heading2": "#0a0a0a",
      "heading3": "#0a0a0a",
      "heading4": "#0a0a0a",
      "link": "#6200ff",
      "linkHover": "#5800e6",
      "inlineCode": "#005c2f",
      "inlineCodeBackground": "#c2c2c2",
      "blockquote": "#505050",
      "blockquoteBorder": "#8b8b8b",
      "listMarker": "#6200ffbf",
      "bold": "#0a0a0a",
      "italic": "#0a0a0ae6",
      "strikethrough": "#505050",
      "hr": "#8b8b8b"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#cd9386",
        "foreground": "#000000",
        "contrast": 8.11
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#a8503b",
        "foreground": "#ffffff",
        "contrast": 5.42
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#ac8643",
        "foreground": "#000000",
        "contrast": 6.25
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#dbd98a",
        "foreground": "#000000",
        "contrast": 14.3
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#75973f",
        "foreground": "#000000",
        "contrast": 6.25
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#65cc62",
        "foreground": "#000000",
        "contrast": 10.37
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#88d9a6",
        "foreground": "#000000",
        "contrast": 12.52
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#438e78",
        "foreground": "#000000",
        "contrast": 5.38
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#86c7d7",
        "foreground": "#000000",
        "contrast": 11.16
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#397893",
        "foreground": "#ffffff",
        "contrast": 4.9
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#354987",
        "foreground": "#ffffff",
        "contrast": 8.56
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#4838a3",
        "foreground": "#ffffff",
        "contrast": 8.86
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#987ed1",
        "foreground": "#000000",
        "contrast": 6.24
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c75cc6",
        "foreground": "#000000",
        "contrast": 5.77
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#8a3b78",
        "foreground": "#ffffff",
        "contrast": 7.05
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#d481aa",
        "foreground": "#000000",
        "contrast": 7.52
      }
    ]
  }
}
